import service from "../services/groups.service";

export const groups = {
    namespaced: true,
    state: {
        groups: [],
        groupsCache: null,
        groupsCacheTime: null,
    },
    getters: {
        allGroups: (state) => state.groups,
    },
    actions: {
        /** Lista con paginación simple (para tablas). */
        async fetchData({ commit }) {
            try {
                const response = await service.getAll();
                const rows = Array.isArray(response.data) ? response.data : [];
                commit('SET_GROUPS', rows);
                return rows;
            } catch (error) {
                console.error("Error fetching groups:", error);
                throw error.response;
            }
        },
        /** Lista completa con caché de 5 minutos (para selects). */
        async getAll({ commit, state }) {
            const now = Date.now();
            if (state.groupsCache && state.groupsCacheTime && (now - state.groupsCacheTime < 300000)) {
                return state.groupsCache;
            }
            try {
                const response = await service.getAll();
                const rows = Array.isArray(response.data) ? response.data : [];
                commit('SET_GROUPS_CACHE', rows);
                commit('SET_GROUPS_CACHE_TIME', now);
                return rows;
            } catch (error) {
                console.error("Error fetching groups:", error);
                throw error.response;
            }
        },
        async getData(context, id) {
            try {
                const response = await service.getData(id);
                return response.data;
            } catch (error) {
                console.error("Error fetching group:", error);
                throw error.response;
            }
        },
        async save({ commit }, data) {
            try {
                let response;
                if (data.id === 0) {
                    response = await service.createData(data);
                } else {
                    response = await service.updateData(data.id, data);
                }
                // Invalidar caché para reflejar los cambios
                commit('SET_GROUPS_CACHE', null);
                commit('SET_GROUPS_CACHE_TIME', null);
                return response;
            } catch (error) {
                console.error("Error saving group:", error);
                return error.response;
            }
        },
        async delete({ commit }, id) {
            try {
                const response = await service.deleteData(id);
                commit('SET_GROUPS_CACHE', null);
                commit('SET_GROUPS_CACHE_TIME', null);
                return response;
            } catch (error) {
                console.error("Error deleting group:", error);
                throw error.response;
            }
        },
        async getAvailableUsers(context, params) {
            try {
                const response = await service.getAvailableUsers(params);
                return response.data;
            } catch (error) {
                console.error("Error fetching available users:", error);
                throw error.response;
            }
        },
    },
    mutations: {
        SET_GROUPS(state, groups) {
            state.groups = groups;
        },
        SET_GROUPS_CACHE(state, groups) {
            state.groupsCache = groups;
        },
        SET_GROUPS_CACHE_TIME(state, time) {
            state.groupsCacheTime = time;
        },
    },
};
